$().ready(function () {
    var $header = $('.site-header'),
    $arrows = $('.arrow-nav'), 
    $window = $(window);
    $window.scroll(function () {
        setTimeout(function() { 
            $arrows.toggleClass('lol', $window.scrollTop() > $header.height());
        }, 1000);  
    });
}); 
